import React from "react";
import { Box, Typography } from "@mui/material";

const PreviewContact = ({ data }) => (
  <Box>
    <Typography variant="body2" fontWeight={600}>
      {data.heading || "—"}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {data.submitBtnText}
    </Typography>
  </Box>
);

export default PreviewContact;